import { useCurrentCompany } from './use-current-company';

/**
 * Company-scope Bizy availability — answers "is this company in the Bizy program?"
 *
 * Backed by `company.bizy_enabled` from the CompanyBlueprint, which is the
 * cascade of tier eligibility (Free/Team always-on) + the bizy-for-participation
 * flag (Org plan gating).
 *
 * For the per-user "should we render Bizy for this user right now?" question,
 * use `useIsBizyEnabledForUser` instead.
 */
export function useIsBizyEnabledForCompany(): boolean {
	const company = useCurrentCompany();
	return company?.bizy_enabled ?? false;
}
